<template>
  <v-card>{{ $t('customizeYourEmail') }}</v-card>
</template>
<script>
export default {
    name: 'OnboardingCustomizeEmail'
}
</script>